export const FileConfig = {
  imageAccept: 'image/*',
  videoAccept: 'video/mp4,video/x-m4v,video/*',
  fileAccept: '.xlsx, .xls, .csv',
};
